import { AllPage } from "@/components/customers/all-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
  component: AllPage,
});
